<template>

    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">

            <ButtonsIcon 
                :icon="icon"
                :color="color"
                @clicked="emit('clicked', $event)"
                v-bind="attrs"
                v-on="on"
            />

        </template>

        <span>{{ label }}</span>

    </v-tooltip>
</template>

<script setup>

import { defineEmits, defineProps } from 'vue';

const emit = defineEmits(['clicked'])

const props = defineProps({
    icon: { type: String, default: 'mdi-microsoft-excel' },
    color: { type: String, default: 'success darken-1' },
    label: { type: String, default: 'Baixar relatório' },
})

</script>